/* eslint-disable */

import React from 'react';
import './spinner.scss';
import spinnerSvg from './images/spinner.svg';
type Props = {
  message?: string | null | undefined;
};
export class Spinner extends React.PureComponent<Props, any> {
  render() {
    const { message } = this.props;
    return (
      <div className="spinner">
        <img src={spinnerSvg} />
        {message && <div className="spinner-message">{message || ''}</div>}
      </div>
    );
  }
}
